import { FC, PropsWithChildren, useRef } from 'react'
import { AnimatePresence, useInView } from 'framer-motion'

import { theme } from 'styles/theme'
import { useAppContext } from 'context/app-context'
import {
  ViewportContainer,
  Button,
  Container,
  Icon,
  Line,
  ScrollToTop,
} from './styled'

const buttonVariants = {
  hidden: {
    scale: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
  visible: {
    scale: 1,
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.inOut,
    },
  },
}

export const IntroContainer: FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null)
  const isHeaderVisible = useInView(ref)
  const { isHome } = useAppContext()

  const handleScroll = () => {
    const boundingRect = ref.current?.getBoundingClientRect()

    if (boundingRect) {
      window.scrollBy({
        top: Math.round(
          boundingRect.height + boundingRect.top - document.body.scrollTop
        ),
      })
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0 })
  }

  return (
    <>
      <Container ref={ref}>
        <ViewportContainer>{children}</ViewportContainer>

        <Line>
          <Button onClick={handleScroll}>
            <Icon />
          </Button>
        </Line>
      </Container>

      <AnimatePresence>
        {!isHeaderVisible && isHome && (
          <ScrollToTop
            onClick={scrollToTop}
            variants={buttonVariants}
            initial="hidden"
            exit="hidden"
            animate="visible"
          />
        )}
      </AnimatePresence>
    </>
  )
}
